import Spinner from './Spinner.vue';

export default Spinner;
